/*! *****************************************************************************
# File Name    : cropper.ts
# Author       : Zhang Yu
# E-mail        : 114233763@qq.com
# Creation Time: 2025-08-07 11:55:00
# Description  : 图片裁剪
#
***************************************************************************** */
import { LoaderWindow } from "@/plugins/loader-window";

class ImageCropperOptions {
  file = "";
  aspectRatio = "4/3";
  width = 400;
  height = 300;

  constructor(options = {}) {
    Object.assign(this, options);
  }
}

export class ImageCropper {
  static open(options = new ImageCropperOptions()) {
    return LoaderWindow.open({
      component: () => import("./ImageCropperView.vue"),
      top:'120px',
      width:'600px',
      props: options,
    });
  }
}

// Vue2 插件包装
export const ImageCropperPlugin = {
  install(Vue) {
    Vue.prototype.$imageCropper = {
      open: ImageCropper.open,
    };
  },
};
